var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.192 0.996501C11.5206 -0.332167 13.6748 -0.332167 15.0035 0.996502C16.3005 2.29354 16.3314 4.37725 15.0961 5.71175L15.0035 5.80804L14.0534 6.75814C14.0532 6.75836 14.0529 6.75859 14.0527 6.75881C14.0525 6.75903 14.0523 6.75925 14.0521 6.75947L5.02039 15.7911C4.90577 15.9058 4.75614 15.9773 4.59663 15.9954L4.51617 16H0.713079C0.342422 16 0.0378176 15.7172 0.00326428 15.3556L0 15.2869V11.4838C0 11.3217 0.0551959 11.1653 0.15518 11.0397L0.208856 10.9796L9.24049 1.94797C9.24073 1.94774 9.24096 1.94751 9.24119 1.94727C9.24142 1.94704 9.24166 1.94681 9.24189 1.94658L10.192 0.996501ZM9.74541 3.45994L1.4265 11.7787V14.5735H4.22126L12.5401 6.25459L9.74541 3.45994ZM13.5485 5.24614L10.7539 2.45149L11.2004 2.00495L11.2819 1.92787C12.0578 1.23415 13.2499 1.25984 13.9951 2.00495L14.0721 2.08645C14.7659 2.86239 14.7402 4.05448 13.9951 4.79959L13.5485 5.24614Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.7cc5afc61773e1d9618a9861e2740c91.svg";
export { ForwardRef as ReactComponent };